<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 81.908 78.762"
       :aria-labelledby="iconName"
       role="presentation">
    <title :id="iconName" lang="en">{{iconName}}</title>
    <g :fill="color">
      <path d="M40.167,78.762C18.019,78.762,0,61.097,0,39.383C0,17.667,18.019,0,40.167,0 c8.806,0,17.216,2.785,24.32,8.055c1.383,1.025,1.672,2.977,0.646,4.359c-1.024,1.381-2.976,1.673-4.359,0.647 c-6.022-4.467-13.148-6.828-20.607-6.828c-18.711,0-33.934,14.871-33.934,33.149c0,18.277,15.223,33.147,33.934,33.147 c18.712,0,33.935-14.87,33.935-33.147c0-2.56-0.285-5.049-0.846-7.399c-0.399-1.674,0.634-3.355,2.308-3.755 c1.668-0.4,3.354,0.633,3.755,2.308c0.674,2.824,1.016,5.8,1.016,8.847C80.334,61.097,62.316,78.762,40.167,78.762z"/>
      <path d="M39.38,58.264c-0.825,0-1.618-0.327-2.204-0.912L15.887,36.065c-1.217-1.217-1.217-3.19,0-4.407 c1.217-1.217,3.19-1.218,4.407,0l18.957,18.955L76.467,8.927c1.147-1.284,3.118-1.395,4.4-0.249c1.284,1.146,1.396,3.116,0.25,4.4 L41.705,57.223c-0.571,0.64-1.38,1.016-2.236,1.04C39.438,58.264,39.409,58.264,39.38,58.264z"/>
    </g>
  </svg>
</template>

<script>
  export default {
    props: {
      iconName: {
        type: String,
        default: ''
      },
      width: {
        type: [Number, String],
        default: 20
      },
      height: {
        type: [Number, String],
        default: 20
      },
      color: {
        type: String,
        default: 'green'
      }
    }
  }
</script>